import styled from '@emotion/styled'
import { Trans, useTranslation } from 'react-i18next'

import { useTypedSelector } from '../..'
import { isCommuterUser } from '../../lib/roleUtils'
import { color, getColor } from '../../Theme'
import ErrorText from '../ErrorText'
import Text from '../Text'

const NoticeText = styled(Text)`
  text-transform: uppercase;
  font-size: 12px;
  color: ${(p) => getColor(p.theme, ['grayDark'], ['grayPink'])};
`

const MissingPhoneError = styled(ErrorText)`
  color: red;
`

const TelLink = ({ phoneNumber, fallbackText }: { phoneNumber?: string; fallbackText: string }) =>
  phoneNumber ? (
    <a href={`tel:${phoneNumber}`} style={{ color: color('primaryBlue') }}>
      {phoneNumber}
    </a>
  ) : (
    <MissingPhoneError>{fallbackText}</MissingPhoneError>
  )

interface PhoneSupportNoticeProps {
  marginBottom?: string
}

const PhoneSupportNotice = ({ marginBottom = '10px' }: PhoneSupportNoticeProps): JSX.Element => {
  const { t } = useTranslation()
  const isCommuter = useTypedSelector((state) => isCommuterUser(state.user))
  const { phoneKuljettajienTukipalvelu, phoneHenkilokuntaTukipalvelu, phoneCommuterTekv } =
    useTypedSelector((state) => state.configurations.data)

  return (
    <NoticeText style={{ marginBottom }}>
      {isCommuter ? (
        <Trans
          i18nKey="defect.create.reportRestrictiveDefectsByPhoneCommuter"
          components={{
            tekvTel: (
              <TelLink
                phoneNumber={phoneCommuterTekv}
                fallbackText={t('errors.defect.noPhoneNumber')}
              />
            ),
          }}
        />
      ) : (
        <Trans
          i18nKey="defect.create.reportRestrictiveDefectsByPhone"
          components={{
            driverTel: (
              <TelLink
                phoneNumber={phoneKuljettajienTukipalvelu}
                fallbackText={t('errors.defect.noPhoneNumber')}
              />
            ),
            otherTel: (
              <TelLink
                phoneNumber={phoneHenkilokuntaTukipalvelu}
                fallbackText={t('errors.defect.noPhoneNumber')}
              />
            ),
          }}
        />
      )}
    </NoticeText>
  )
}

export default PhoneSupportNotice
